import { render, staticRenderFns } from "./dormJudge.vue?vue&type=template&id=75e5d67b&scoped=true"
import script from "./dormJudge.vue?vue&type=script&lang=js"
export * from "./dormJudge.vue?vue&type=script&lang=js"
import style0 from "./dormJudge.vue?vue&type=style&index=0&id=75e5d67b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e5d67b",
  null
  
)

export default component.exports